import { ImageViewFill, ImageViewFit } from '../../image/image-view';
import { MultipleChoiceOption } from '../multiple-choice.constants';
import { isImageLayoutFill } from '../multiple-choice.utils';

const MultipleChoiceImage = ({ option }: { option: MultipleChoiceOption }) => (
  <>
    {!isImageLayoutFill(option.imageLayout) ? (
      <ImageViewFit
        altText={option.image?.alt}
        imageUrls={option.imageUrls || []}
      />
    ) : (
      <ImageViewFill
        altText={option.image?.alt}
        imageUrls={option.imageUrls || []}
      />
    )}
  </>
);

export default MultipleChoiceImage;
